// converter for data in Compare Popup
import {
  normalizePriceInfoForProduct
} from './helpers/converterHelper';

export function getBasicInfoDataFromStoreAPIForCompareProducts(storeAPIData, storeStockAPIData, productDataFromSearchLabs) {
  const productsBasicInfo = [];

  storeAPIData.forEach((productData, i) => {

    const productStockInfo = storeStockAPIData.find((avail) => avail.productId === productData.id);

    const clearance =
      productDataFromSearchLabs.find((product) => (product.id === productData.id))
        ?.tags.split(',')?.findIndex((tag) => tag.trim() === 'Clearance') !== -1;


    productsBasicInfo[i] = {
      productId: productData.id,
      productLabel: `${productData.brand.label} ${productData.label}`,
      productImageUrl: (Array.isArray(productData.images) && productData.images[0] && productData.images[0].url)
        ? productData.images[0].url.replace(/\/[a-z]_(.*?).jpg/, '\/s_$1.jpg') // eslint-disable-line no-useless-escape
        : 'https://currys-ssl.cdn.dixons.com/grafx/images/logos/logo.png', // if image no coming from brain add Currys logo
      price: normalizePriceInfoForProduct(productData),
      isDownload: productData.boxType === 'download',
      productLink: productData.link,
      customerReview: productData.customerReview,
      boxType: productData.boxType,
      forwardOrder: productData.forwardOrder,
      preOrder: productData.preOrder,
      delivery: productData.delivery,
      checkInStock: productData.checkInStock,
      ...(productStockInfo && { stockChecked: true }),
      ...(productStockInfo && { inStock: productStockInfo.quantityAvailable > 0 }),
      clearance: !!clearance
    };
  });

  return productsBasicInfo;
}


export function normalizeProductsDataForTechnicalSpecificationsTable(productsTechnicalSpecificationsInfo) {
  const productDataForTechnicalSpecificationsTable = [];

  const allTechnicalSpecificationGroupsForProducts = [];
  productsTechnicalSpecificationsInfo.forEach((currentProductTechnicalSpecifications) => {
    currentProductTechnicalSpecifications.forEach((currentProductTechnicalSpecificationGroup) => {
      if (!allTechnicalSpecificationGroupsForProducts.includes(currentProductTechnicalSpecificationGroup.groupLabel)) {
        allTechnicalSpecificationGroupsForProducts.push(currentProductTechnicalSpecificationGroup.groupLabel);
      }
    });
  });

  allTechnicalSpecificationGroupsForProducts.forEach(
    (currentTechnicalSpecificationGroupName, currentTechnicalSpecificationGroupIndex) => {
      productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex] = {
        sectionLabel: currentTechnicalSpecificationGroupName,
        rows: []
      };

      const allSpecificationNamesForCurrentGroup = [];

      productsTechnicalSpecificationsInfo.forEach((currentProductTechnicalSpecifications) => {
        const currentProductSpecificationsFromGroup =
          currentProductTechnicalSpecifications.find((technicalSpecification) =>
            technicalSpecification.groupLabel === currentTechnicalSpecificationGroupName
          );

        if (currentProductSpecificationsFromGroup) {
          currentProductSpecificationsFromGroup.specifications.forEach((currentSpecification) => {
            if (!allSpecificationNamesForCurrentGroup.includes(currentSpecification.label)) {
              allSpecificationNamesForCurrentGroup.push(currentSpecification.label);
            }
          });
        }
      });

      allSpecificationNamesForCurrentGroup.forEach(
        (currentSpecificationNameForCurrentGroup, currentSpecificationForCurrentGroupIndex) => {
          productsTechnicalSpecificationsInfo.forEach((currentProductTechnicalSpecifications) => {
            const productCurrentGroupSpecifications = currentProductTechnicalSpecifications.find((specificationGroup) => (
              specificationGroup.groupLabel === currentTechnicalSpecificationGroupName
            ));

            let productCurrentSpecification;

            if (productCurrentGroupSpecifications) {
              productCurrentSpecification = productCurrentGroupSpecifications.specifications.find(
                (specification) => specification.label === currentSpecificationNameForCurrentGroup
              );
            }

            if (productCurrentGroupSpecifications && productCurrentSpecification) {
              if (productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
                .rows[currentSpecificationForCurrentGroupIndex]) {
                productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
                  .rows[currentSpecificationForCurrentGroupIndex].firstColumnLabel = productCurrentSpecification.label;
                productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
                  .rows[currentSpecificationForCurrentGroupIndex].otherColumnsLabels.push(productCurrentSpecification.value);
              } else {
                productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
                  .rows[currentSpecificationForCurrentGroupIndex] = {
                    firstColumnLabel: productCurrentSpecification.label,
                    otherColumnsLabels: [productCurrentSpecification.value]
                  };
              }
            } else if (productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
              .rows[currentSpecificationForCurrentGroupIndex]) {
              productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
                .rows[currentSpecificationForCurrentGroupIndex].otherColumnsLabels.push('-');
            } else {
              productDataForTechnicalSpecificationsTable[currentTechnicalSpecificationGroupIndex]
                .rows[currentSpecificationForCurrentGroupIndex] = {
                  otherColumnsLabels: ['-']
                };
            }
          });
        });
    });

  return productDataForTechnicalSpecificationsTable;
}
